import React from 'react';
import logoImage from 'views/components/molecules/Splash/images/logo.png';
import { Image } from 'views/components/atoms/Image';
import styled from '@emotion/styled';
import { Color } from 'views/constants';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const ContentsWrapper = styled.div`
  background-color: ${Color.C5};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

// Imageのサイズは固定
const ImageWrapper = styled.div`
  width: 189px;
  height: 36px;
`;

export const Splash: React.FC = () => (
  <Wrapper>
    <ContentsWrapper>
      <ImageWrapper>
        <Image src={logoImage} />
      </ImageWrapper>
    </ContentsWrapper>
  </Wrapper>
);
